import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vant from 'vant';
import 'vant/lib/index.css';
import 'amfe-flexible/index.js'
import "./assets/css/css.css";
import VueCookies from 'vue-cookies'
import {
	axios_get,
	axios_post
} from './utils/axios';

import {
  getSign
}from './utils/tool'

Vue.use(VueCookies)
Vue.use(Vant);
Vue.config.productionTip = false
Vue.prototype.$ajaxGet = axios_get;
Vue.prototype.$ajaxPost = axios_post;
Vue.prototype.$getSign = getSign;

Vue.directive('title', {//单个修改标题
  update: function (el) {
      document.title = el.getAttribute("data-title")
    }
 })

Vue.prototype.$upload='https://vipapi.app.cctv.com/file-server/api/resources/files/upload';//单传 {file:xx}
Vue.prototype.$uploads='https://vipapi.app.cctv.com/file-server/api/resources/files/uploads';//单传 {file:xx}
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
